<template>
  <Transition name="modal">
    <div v-if="show" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
          <div
              class="modal-container relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
          >
            <div class="relative bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

              <i class="fa fa-times cursor-pointer absolute top-4 right-4" @click="close()"></i>
              <div class="sm:flex sm:items-start">

                <slot />

              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse flex justify-between gap-4 sm:px-6">
              <button v-if="showActionBtn" type="button" :class="btnClass"
                      class="block w-full md:w-auto md:inline-flex justify-center text-sm md:text-base btn ml-2" @click="$emit('actionClicked')"
              >{{ actionText }}
              </button>
              <button type="button" @click="close()"
                      class="hidden md:inline-flex justify-center rounded-md border text-sm md:text-base border-gray-300 bg-white px-4 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >{{ __('general.close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
    mistake: {
      type: Object,
      required: false,
    },
    question: {
      type: Object,
      required: false,
    },
    btnClass: {
      type: String,
      required: false,
      default: 'btn-primary',
    },
    showActionBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    actionText: {
      type: String,
      required: false,
    },
  },

  emits: ['close'],

  methods: {
    close: function () {
      this.$emit('close')
    },
  },
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>